import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from "@reduxjs/toolkit/query/react";
import { userAuthApi } from '../services/userAuth';
import loginAuthReducer, { sliceName as authSliceKey } from '../pages/auth/LoginAuthSlice';
import redirectReducer, { sliceName as redirectSliceKey } from '../components/redirect/redirectSlice';
import { rtkQueryErrorLogger } from './middleware';
import graphSectionSliceReducer, { sliceName as graphSection } from '../layouts/dashboard/dashboard-home/GraphSectionSlice';
// import PdfEditSliceReducer, { sliceName as pdfEdit } from '../components/dashboard/onboarding/PDF/PdfEditSlice';
// import OnboardingDetailsSlice, { sliceName as onboardingDetailsSlice } from '../components/dashboard/onboarding/client-onboarding-form/OnboardingSlice';
// import FaqEditSlice, { sliceName as faqEditSliceKey } from '../pages/client/faq/components/add-edit-faq-modal/FaqEditSlice'
import sidebarSliceReducer, { sliceName as sidebarSliceKey } from '../components/sidebar/SidebarSlice';
// import AddProjectSlice, { sliceName as addProjectSliceKey } from '../components/sales/add-project/AddProjectSlice';
// import DataCollectionSlice, { sliceName as dataCollectionSliceKey } from '../components/sales/add-project/services-enter-components/data-collection/data-collection-table/DCTableSlice';
// import PoaSlice, { sliceName as poaSliceKey } from '../pages/operations/project/pre-launch/make-poa/PoaSlice';
import MasterFileProjectSlice, { sliceName as masterFileProjectSliceKey } from '../components/outlook/outlook-graph/select-directory/MasterFileProjectSlice';
// persists store
import storage from 'redux-persist/lib/storage';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2'
import { persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import { combineReducers } from 'redux';
import { projectsApi } from '../services/operations/project';
import { cipClientApi } from '../services/kmt/cipClient'
import { rfqApi } from '../services/kmt/rfq.service'
import { faqApi } from '../services/curated/faq'
import { clientProjectApi } from '../services/connect/clientProject'

import cipClientReducer, { sliceName as cipClientSliceKey } from '../pages/knowledge-management/cip/components/add-client/CIPClientSlice';
import ProjectDetailMarketResearchFullServiceReducer, { sliceName as ProjectDetailMarketResearchFullServiceSliceKay } from '../pages/client/projects/project-detail/project-detail-mrfsc/ProjectDetailMarketResearchFullServiceSlice';
import { REACT_APP_RTK_DEVTOOLS_STATE } from '../config/reactConstants';
import { employeeCenterAPI } from '../services/kmt/employeeCenter';


const reducers = combineReducers({
  [userAuthApi.reducerPath]: userAuthApi.reducer,
  // faq is being fetched from curated CMS
  [faqApi.reducerPath]: faqApi.reducer,
  [projectsApi.reducerPath]: projectsApi.reducer,
  [employeeCenterAPI.reducerPath]: [employeeCenterAPI.reducer],
  [cipClientApi.reducerPath]: cipClientApi.reducer,
  [clientProjectApi.reducerPath]: clientProjectApi.reducer,
  [rfqApi.reducerPath]: rfqApi.reducer,
  [redirectSliceKey]: redirectReducer,
  [graphSection]: graphSectionSliceReducer,
  // [pdfEdit]: PdfEditSliceReducer,
  // [onboardingDetailsSlice]: OnboardingDetailsSlice,
  [authSliceKey]: loginAuthReducer,
  [graphSection]: graphSectionSliceReducer,
  [masterFileProjectSliceKey]: MasterFileProjectSlice,
  // [faqEditSliceKey]: FaqEditSlice,
  [sidebarSliceKey]: sidebarSliceReducer,
  // [addProjectSliceKey]: AddProjectSlice,
  // [dataCollectionSliceKey]: DataCollectionSlice,

  [cipClientSliceKey]: cipClientReducer,
  [ProjectDetailMarketResearchFullServiceSliceKay]: ProjectDetailMarketResearchFullServiceReducer
})

const persistedReducer = persistReducer({
  key: 'root',
  storage,
  stateReconciler: autoMergeLevel2,
  whitelist: [authSliceKey]
}, reducers)

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: {
      ignoreActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
    }
  }).concat(
    rtkQueryErrorLogger,
    faqApi.middleware,
    projectsApi.middleware,
    cipClientApi.middleware,
    clientProjectApi.middleware
  ),
  devTools: REACT_APP_RTK_DEVTOOLS_STATE
});


setupListeners(store.dispatch);